/* Women's Work custom additions (added July 2026)
   1. AJAX add-to-cart for the quick add buttons on product cards.
   2. Gift wrapping toggle in the cart drawer.
   3. Bundle savings nudges in the cart drawer (buy 3 x 330g save $5, etc).
   4. Flavour suggestion rail beside the cart drawer.
   All dispatch the same events the Impulse theme uses so the
   cart drawer opens and rebuilds exactly like a normal add. */
(function () {
  var addUrl = function () {
    return (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';
  };

  /* --- 1. Quick add-to-cart on product cards (also used by the rail) --- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target && evt.target.closest ? evt.target.closest('[data-ww-quick-add]') : null;
    if (!form) return;
    evt.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('input[name="id"]');
    if (!btn || !idInput) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (product) {
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: product, addToCartBtn: btn },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        form.removeAttribute('data-ww-quick-add');
        form.submit();
      });
  });

  /* --- 2. Gift wrapping toggle in the cart drawer --- */
  var wrapBusy = false;

  function wrapEl() {
    return document.querySelector('[data-ww-gift-wrap]');
  }

  function updateGiftWrap(cart) {
    var el = wrapEl();
    if (!el) return;
    var handle = el.getAttribute('data-wrap-handle');
    var inCart = cart.items.some(function (item) { return item.handle === handle; });
    var box = el.querySelector('[data-ww-gift-wrap-toggle]');
    if (box) box.checked = inCart;
  }

  document.addEventListener('change', function (evt) {
    var box = evt.target && evt.target.hasAttribute && evt.target.hasAttribute('data-ww-gift-wrap-toggle') ? evt.target : null;
    if (!box || wrapBusy) return;
    var el = wrapEl();
    if (!el) return;
    wrapBusy = true;
    box.disabled = true;
    var variantId = parseInt(el.getAttribute('data-wrap-variant'), 10);
    var handle = el.getAttribute('data-wrap-handle');

    var done = function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
      wrapBusy = false;
      box.disabled = false;
      setTimeout(syncCartExtras, 400);
    };

    if (box.checked) {
      fetch(addUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(done).catch(function () { box.checked = false; wrapBusy = false; box.disabled = false; });
    } else {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].handle === handle) { line = i + 1; break; }
          }
          if (!line) { wrapBusy = false; box.disabled = false; return; }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ line: line, quantity: 0 })
          }).then(done);
        })
        .catch(function () { wrapBusy = false; box.disabled = false; });
    }
  });

  /* --- 3. Bundle savings nudges in the cart drawer ---
     Counts individual jars per size by the weight in the title
     (330g/320g = large, 115g = petite). Excludes Trio, Dozen and
     other Build Your Own bundles, and food service tubs. */
  function jarCounts(cart) {
    var counts = { grande: 0, petite: 0 };
    cart.items.forEach(function (item) {
      if (item.product_type !== 'Relish') return;
      var t = (item.title || '').toUpperCase();
      if (t.indexOf('TRIO') !== -1 || t.indexOf('DOZEN') !== -1 || t.indexOf('BUILD YOUR OWN') !== -1 || t.indexOf('TUB') !== -1) return;
      if (t.indexOf('330G') !== -1 || t.indexOf('320G') !== -1 || t.indexOf('GRANDE') !== -1) counts.grande += item.quantity;
      else if (t.indexOf('115G') !== -1 || t.indexOf('PETITE') !== -1) counts.petite += item.quantity;
    });
    return counts;
  }

  function nudgeLine(n, unit, label) {
    if (!n) return '';
    var k = Math.floor(n / 3);
    var r = n % 3;
    var saved = k * unit;
    var next = (k + 1) * unit;
    if (r === 1) {
      if (k === 0) return 'Add 2 more ' + label + ' jars and save $' + unit;
      return 'You’re saving $' + saved + ' on ' + label + ' jars. Add 2 more to save $' + next;
    }
    if (r === 2) {
      if (k === 0) return 'Add 1 more ' + label + ' jar and save $' + unit;
      return 'You’re saving $' + saved + ' on ' + label + ' jars. Add 1 more to save $' + next;
    }
    return 'You’re saving $' + saved + ' on ' + label + ' jars! Add another 3 to save $' + next;
  }

  function updateNudge(cart) {
    var el = document.querySelector('[data-ww-bundle-nudge]');
    if (!el) return;
    var counts = jarCounts(cart);
    var lines = [];
    var g = nudgeLine(counts.grande, 5, '330g');
    var p = nudgeLine(counts.petite, 4, '115g');
    if (g) lines.push(g);
    if (p) lines.push(p);
    if (!lines.length) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    el.innerHTML = '<p class="ww-bundle-nudge__heading">Bundle &amp; save</p>' +
      lines.map(function (l) { return '<p class="ww-bundle-nudge__line">' + l + '</p>'; }).join('');
    el.hidden = false;
  }

  /* --- 4. Flavour suggestion rail beside the drawer --- */
  function railEl() {
    return document.querySelector('[data-ww-rail]');
  }

  function updateRail(cart) {
    var rail = railEl();
    if (!rail) return;
    var counts = jarCounts(cart);
    var have = {};
    cart.items.forEach(function (item) { have[item.handle] = true; });
    var sizes = {};
    if (counts.grande > 0) sizes.grande = true;
    if (counts.petite > 0) sizes.petite = true;
    var shown = 0;
    var max = 4;
    var items = rail.querySelectorAll('[data-ww-rail-item]');
    Array.prototype.forEach.call(items, function (item) {
      var ok = shown < max && sizes[item.getAttribute('data-size')] === true && !have[item.getAttribute('data-handle')];
      item.hidden = !ok;
      if (ok) shown++;
    });
    rail.setAttribute('data-has-items', shown > 0 ? 'true' : 'false');
    railVisibility();
  }

  function railVisibility() {
    var rail = railEl();
    var drawer = document.getElementById('CartDrawer');
    if (!rail || !drawer) return;
    var open = (drawer.className || '').indexOf('is-open') !== -1;
    var hasItems = rail.getAttribute('data-has-items') === 'true';
    var wide = window.innerWidth >= 1000;
    if (open && hasItems && wide) {
      rail.style.right = drawer.offsetWidth + 'px';
      if (rail.hidden) {
        rail.hidden = false;
        requestAnimationFrame(function () { rail.classList.add('is-visible'); });
      } else {
        rail.classList.add('is-visible');
      }
    } else {
      rail.classList.remove('is-visible');
      rail.hidden = true;
    }
  }

  /* --- Shared cart sync: one fetch keeps gift wrap, nudges and rail in step --- */
  function syncCartExtras() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateGiftWrap(cart);
        updateNudge(cart);
        updateRail(cart);
      })
      .catch(function () {});
  }

  function initObservers() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(railVisibility).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', railVisibility);
    syncCartExtras();
  }

  document.addEventListener('cart:updated', function () { setTimeout(syncCartExtras, 200); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(syncCartExtras, 400); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObservers);
  } else {
    initObservers();
  }
})();
